import { render, staticRenderFns } from "./reportInfomation.vue?vue&type=template&id=65a55278&scoped=true"
import script from "./reportInfomation.vue?vue&type=script&lang=js"
export * from "./reportInfomation.vue?vue&type=script&lang=js"
import style0 from "./reportInfomation.vue?vue&type=style&index=0&id=65a55278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a55278",
  null
  
)

export default component.exports